import { render } from "./cell.vue?vue&type=template&id=38851993&scoped=true"
import script from "./cell.vue?vue&type=script&lang=js"
export * from "./cell.vue?vue&type=script&lang=js"

import "./cell.vue?vue&type=style&index=0&id=38851993&scoped=true&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38851993"]])

export default __exports__